//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import TopScreen from '~/components/TopScreen.vue'
import FooterTop from '~/components/footer/footerTop.vue'
import DescriptionCard from '~/components/forGaming/DescriptionCard.vue'
import HowItWorks from '~/components/common/HowItWork.vue'

export default {
  components: {
    TopScreen,
    FooterTop,
    DescriptionCard,
    HowItWorks
  },
  head () {
    return {
      title: this.$t('footer.products-services.ewallet').concat(' | Pagsmile '),
      meta: [
        {
          hid: 'description',
          name: 'description',
          content: this.$t('seo.description')
        }
      ]
    }
  },
  data () {
    return {
      hiw: {
        title: 'digital-wallets.block3.title',
        subtitle: 'digital-wallets.block3.text',
        steps: [
          'digital-wallets.block3.item1',
          'digital-wallets.block3.item2',
          'digital-wallets.block3.item3',
          'digital-wallets.block3.item4'
        ],
        imgs: [
          require('@/assets/img/products-services/digital-wallets/b3-1.png'),
          require('@/assets/img/products-services/digital-wallets/b3-2.png'),
          require('@/assets/img/products-services/digital-wallets/b3-3.png'),
          require('@/assets/img/products-services/digital-wallets/b3-4.png')
        ]
      }
    }
  }
}
